<template>
  <div>
    <b-button @click="showForm = !showForm" variant="primary">{{text}}</b-button>

    <b-modal id="modal-1" :title="text" v-model="showForm"
      size="xl"
      scrollable
      @ok="handleOk"
      @cancel="handleCancel">
      <div>
        <b-row>
          <b-col class="p-4 text-left">
            <b-form-group>
              <b-input-group size="sm">
                <b-form-input
                  v-model="search"
                  placeholder="Search"
                  type="text"
                  debounce="500"
                  >
                </b-form-input>
                <b-input-group-append>
                  <b-button v-on:click="search = ''"><b-icon-x></b-icon-x></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-left">
            <b-button size="sm" variant="link" @click="selectAllRows">Select all</b-button>
            <b-button size="sm" variant="link" @click="clearSelected" :disabled="selectedRows.length === 0">Clear selected</b-button>
          </b-col>
          <b-col class="text-right">
            <b-pagination v-model="pagination.page" :total-rows="pagination.total" :per-page="pagination.pageSize" align="right" v-if="!loading" @change="loadData"></b-pagination>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="p-4">
            <b-table small
            ref="selectableTable"
            :items="users"
            :fields="fields"
            @row-selected="onRowSelected"
            selectable
            select-mode="range"
            :busy="loading"
            class="text-left">
              <template v-slot:table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>

              <template v-slot:cell(name)="data">
                {{data.value}}
              </template>

              <template v-slot:cell(email)="data">
                {{data.value}}
              </template>

            </b-table>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Api from '@/api/Api'

export default {
  props: [ 'text' ],
  data () {
    return {
      fields: [ 'name', 'email' ],
      users: [],
      loading: false,
      search: '',
      showForm: false,
      pagination: {
        pageSize: 500,
        page: 1,
        total: 0
      },
      selectedRows: []
    }
  },
  methods: {
    loadData (page) {
      var vm = this

      if (!vm.search) {
        vm.users = []
        vm.pagination.total = 0
        vm.pagination.pageSize = 500
        vm.pagination.page = 1
        return
      }

      vm.loading = true
      vm.pagination.page = page
      Api().get(`Users?page=${page}&pageSize=${vm.pagination.pageSize}&search=${vm.search}`)
        .then((r) => {
          console.log(r.data)
          vm.users = r.data.items
          vm.pagination.total = r.data.total
          vm.pagination.pageSize = r.data.pageSize
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          vm.loading = false
        })
    },
    handleOk (evt) {
      evt.preventDefault()

      this.$emit('ok', this.selectedRows)

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-1')
      })
    },
    handleCancel () {
      this.$emit('cancel')
    },
    onRowSelected (items) {
      this.selectedRows = items
    },
    selectAllRows () {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected () {
      this.$refs.selectableTable.clearSelected()
    }
  },
  watch: {
    search (value) {
      this.loadData(1)
    }
  }
}
</script>

<style>

</style>
